<template>
  <div id="app" :class="[`path-${$route.name}`]" style="background: hsl(0,0%,0%);">

    <transition name="fademenu">
      <div
      v-show="$route.name!=='Home'||stage=='ENTERED'"
      class="w-full h-full top-0 z-50 pointer-events-none select-none"
      :class="{
        'relative':$route.name!=='Home',
        'fixed':$route.name==='Home',
        }"
      >
        <div
        class="
        absolute
        z-50
        top-0
        m-3
        mt-4
        px-3
        md:my-6
        md:px-6
        md:left-1/2
        md:transform
        md:-translate-x-1/2
        mx-auto
        text-white serif
        pointer-events-auto
        md:mt-6 text-4xl xl:text-7xl 2xl:text-8xl
        transition-transform
        duration-1000
        origin-top
        "
        :class="{
          'md:mt-3__text-4xl__xl:text-3xl__2xl:text-4xl md:scale-50 md:-translate-y-3':$route.name!=='Home',
          'md:mt-6__text-4xl__xl:text-7xl__2xl:text-8xl md:scale-100':$route.name==='Home',
          }"
        >
          <!-- <router-link v-if="$route.path!=='/restitution'" :to="{ name: 'Home', params: {} }">The Collection</router-link>
          <div v-if="$route.path=='/restitution'">Restitution in AR</div> -->
          <router-link :to="{ name: 'Home', params: {} }">The Collection</router-link>
        </div>

        <div class="
        absolute z-50 m-3 mt-8 md:mt-3 top-0 right-0 text-white hover:text-blue serif cursor-pointer text-base xl:text-3xl 2xl:text-4xl
        pointer-events-auto
        "
        :class="{
          'text-white' : $route.name=='Home'||$route.name=='Restitution',
          'text-blue' : $route.name!=='Home'&&$route.name!=='Restitution',
          }"
        @click="toggleMenu">
          <div class="block md:hidden">Information</div>
          <div class="hidden md:block">Information</div>
        </div>

        <div
        class="hidden md:block
        absolute
        z-50 m-3
        top-0 left-0
        text-white
        hover:text-blue serif
        cursor-pointer text-base xl:text-3xl 2xl:text-4xl
        pointer-events-auto
        "
        :class="{
          'text-blue': $route.name === 'Restitution'
          }"
        >
          <router-link :to="{ name: 'Restitution', params: {} }">Restitution in AR</router-link>
          <!-- <router-link v-else :to="{ name: 'Gallery', params: {} }">View Gallery</router-link> -->
        </div>

        <div
        class="block md:hidden
        absolute
        z-50 m-3
        top-0 right-0
        text-white
        hover:text-blue serif
        cursor-pointer text-base xl:text-3xl 2xl:text-4xl
        pointer-events-auto
        "
        :class="{
          'text-blue': $route.name === 'Restitution'
          }"
        >
          <router-link :to="{ name: 'Restitution', params: {} }">Restitution in AR</router-link>
          <!-- <router-link v-else :to="{ name: 'Gallery', params: {} }">View Gallery</router-link> -->
        </div>

        <div
        v-if="$route.name=='Restitution'"
        class="block
        absolute
        z-50 m-3
        bottom-0 left-0
        text-white
        hover:text-blue serif
        cursor-pointer text-base xl:text-3xl 2xl:text-4xl
        pointer-events-auto
        ">
          <router-link :to="{ name: 'Gallery', params: {} }">Your Collection</router-link>
        </div>

        <div
        v-if="$route.name=='Restitution'"
        class="block
        absolute
        z-50 m-3
        bottom-0 right-0
        text-white
        hover:text-blue serif
        cursor-pointer text-base xl:text-3xl 2xl:text-4xl
        pointer-events-auto
        ">
          <router-link :to="{ name: 'Home', params: {} }">View The Collection</router-link>
        </div>



      </div>
    </transition>

    <div
    v-show="$route.name==='Home' && stage!='ENTERED'"
    class="flex flex-col justify-center
      select-none
      text-white
      w-full h-full
      fixed z-50
      p-0 md:p-16
      text-center
      md:w-auto md:h-auto md:top-1/2 md:left-1/2 md:transform md:-translate-y-1/2 md:-translate-x-1/2
      md:whitespace-nowrap
      ">
      <div class="serif mb-4 text-5xl md:text-5xl lg:text-6xl xl:text-7xl">
        The Collection<br>of<br>Jane Ryan<br>&<br> William Saunders
      </div>
      <div class="h-32 px-6 mt-8 md:px-12 md:h-32 flex flex-col justify-center">


          <!-- <div class="" v-show="stage=='LOADED'&&!isInAppBrowser">
            <div
            v-if="!isInAppBrowser"
            @click="clickAR"
            class="inline-block
            bg-blue
            text-white
            hover:text-opacity-50
            serif
            cursor-pointer
            text-2xl
            lg:text-3xl
            xl:text-4xl
            2xl:text-4xl
            border
            border-blue
            mt-6
            py-2
            px-2">
            Restitution in AR</div>

            <div
            v-if="!isInAppBrowser"
            @click="stateUpdateStageAsEntered"
            class="inline-block
            -bg-white
            text-blue
            -bg-opacity-50
            hover:text-opacity-50
            serif
            cursor-pointer
            text-2xl
            lg:text-3xl
            xl:text-4xl
            2xl:text-4xl
            border
            border-blue
            -p-4
            mt-4
            py-2
            px-2">
            View the Collection</div>
          </div> -->

        <!-- <transition name="fadeslow" mode="out-in"> -->
          <div v-show="stage=='LOADED'&&!isInAppBrowser"
          @click="clickAR"
          class="inline-block
          bg-blue
          text-white
          hover:text-opacity-50
          serif
          cursor-pointer
          text-2xl
          lg:text-3xl
          xl:text-4xl
          2xl:text-4xl
          border
          border-blue
          mt-6
          py-2
          px-2">
          Restitution in AR</div>
        <!-- </transition> -->

        <!-- <transition name="fadeslow" mode="out-in"> -->
          <div v-show="stage=='LOADED'&&!isInAppBrowser"
          @click="stateUpdateStageAsEntered"
          class="inline-block
          -bg-white
          text-blue
          -bg-opacity-50
          hover:text-opacity-50
          serif
          cursor-pointer
          text-2xl
          lg:text-3xl
          xl:text-4xl
          2xl:text-4xl
          border
          border-blue
          -p-4
          mt-4
          py-2
          px-2">
          View the Collection</div>
        <!-- </transition> -->

        <!-- <transition name="fadeslow" mode="out-in"> -->
          <div v-show="stage=='LOADING'||isInAppBrowser"
          class="block mx-auto w-96 max-w-full text-white -bg-opacity-50 mt-2 serif pointer-events-none text-xl p-4">

            <div class="p-2 text-2xl serif mx-auto" v-if="isInAppBrowser">
              Please view this site on <span v-if="OperatingSystem=='iOS'">Safari</span><span v-else>Chrome</span> for the full experience with augmented reality.
            </div>
            <div class="" v-else>
              Collecting pieces...
            </div>

          </div>
        <!-- </transition> -->


      </div>
    </div>

    <transition name="fademenu">
      <div class="fixed w-full h-full inset-0 z-50" 
      v-show="($route.name!=='Home'||stage=='ENTERED')&&menuActive"
      >
        <div
          class="
          flex flex-col justify-center
          select-none
          bg-blue
          w-full h-full
          fixed z-50
          p-6 md:p-16
          text-3xl md:text-5xl
          -md:w-auto -md:h-auto -md:top-1/2 -md:left-1/2
          -md:transform -md:-translate-y-1/2 -md:-translate-x-1/2
          md:whitespace-nowrap"
          >
          <!-- <transition name="fade" mode="in-out"> -->
            <div class="" v-if="!essayMenuActive">
              <router-link class="nav-links" :to="{ name: 'About', params: {} }">About</router-link>
              <!-- <a class="nav-links" @click="essayMenuActive=true">Essays</a> -->
              <router-link class="nav-links" :to="{ name: 'Essay', params: {} }">All is Not Forgiven, John Kenneth Paranada</router-link>
              <router-link class="nav-links" :to="{ name: 'QA', params: {} }">Catching Ghosts: A Conversation</router-link>
              <router-link class="nav-links" :to="{ name: 'Pio', params: {} }">Pio Abad and Frances Wadsworth&nbsp;Jones</router-link>
              <router-link class="nav-links" :to="{ name: 'Restitution', params: {} }">Restitution in AR</router-link>
              <router-link class="nav-links" :to="{ name: 'Gallery', params: {} }">Your Collection</router-link>
              <router-link class="nav-links" :to="{ name: 'Credits', params: {} }">Credits</router-link>
              <a class="nav-links" href="https://culturalcenter.gov.ph/online/21am/" target="_blank" rel="noreferrer noopener"> 21AM </a>
            </div>

          <!-- </transition> -->
          <!-- <transition name="fade" mode="in-out"> -->
            <div class="" v-if="essayMenuActive">
              <router-link :key="'Essay'" v-if="essayMenuActive" class="nav-links" :to="{ name: 'Essay', params: {} }">All is Not Forgiven,&nbsp;John Kenneth Paranada</router-link>
              <router-link :key="'QA'" v-if="essayMenuActive" class="nav-links" :to="{ name: 'QA', params: {} }">Catching Ghosts: A Conversation</router-link>
              <a :key="'Back'" v-if="essayMenuActive" class="nav-links" @click="essayMenuActive=false">
                <div class="text-lg">
                  Back
                </div>
              </a>
            </div>
          <!-- </transition> -->

        </div>
        <div class="fixed top-0 right-0 m-6 w-8 h-8 text-6xl z-50 cursor-pointer " @click.prevent.self="toggleMenu" >
          <div class="absolute transform rotate-45 bg-white w-full top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2" style="height:1px;">

          </div>
          <div class="absolute transform -rotate-45 bg-white w-full top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2" style="height:1px;">

          </div>
        </div>
      </div>
    </transition>


    <!-- <div class="fixed w-full h-full inset-0 bg-light flex justify-center text-center items-center" style="z-index:9999999;" v-if="isInAppBrowser">

      <div class="p-4 text-3xl serif">
        Please view this site on <span v-if="OperatingSystem=='iOS'">Safari</span><span v-else>Chrome</span> for the full experience with augmented reality.
      </div>

    </div> -->

    <!-- <Jewellery2 />
    <Jewellery v-if="false"/>
    <GLBTest v-if="false"/> -->
    <transition name="fade" mode="in-out">
      <keep-alive include="Home,Jewellery2">
        <router-view class="router-view" :key="$route.name"/>
      </keep-alive>
    </transition>

  </div>
</template>

<script>
// @ is an alias to /src
// import Jewellery from '@/components/Jewellery.vue'
// import Jewellery2 from '@/components/Jewellery2.vue'
// import GLBTest from '@/components/GLBTest.vue'
export default {
  name: 'App',
  // components: { Jewellery, Jewellery2, GLBTest },
  data () {
    return {
      menuActive: false,
      essayMenuActive: false,
      arActive: false,
      hasEntered: false,
    }
  },
  watch: {
    '$route' (newVal, oldVal) {
      if (newVal.path != oldVal.path) {
        this.menuActive = false
        console.log('$route', newVal.name, oldVal.name )
        if (!this.hasEntered||newVal.name=='Home') {
          this.stateUpdateStageAsEntered()
        }
      }
    }
  },
  computed: {
    stage () {
      return this.$store.state.stage
    },
    isInAppBrowser () {
      let ua = navigator.userAgent || navigator.vendor || window.opera;
      let isInstagram = (ua.indexOf('Instagram') > -1) ? true : false;
      let isFacebook = (ua.indexOf('Facebook') > -1) ? true : false;
      let isMessenger = (ua.indexOf('Messenger') > -1) ? true : false;
      // if (document.documentElement.classList){
      // 	if (isInstagram||isFacebook||isMessenger) {
      // 		// window.document.body.classList.add('instagram-browser');
      //     return true
      // 	} else {
      //     return false
      //   }
      // }
      // return true
      return (isInstagram||isFacebook||isMessenger) ? true : false
    },
    OperatingSystem () {
      let userAgent = navigator.userAgent || navigator.vendor || window.opera;
        // Windows Phone must come first because its UA also contains "Android"
      if (/windows phone/i.test(userAgent)) {
          return "Windows Phone";
      }

      if (/android/i.test(userAgent)) {
          return "Android";
      }

      // iOS detection from: http://stackoverflow.com/a/9039885/177710
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
          return "iOS";
      }

      return "unknown";
    }
  },
  methods: {

    clickAR () {
      this.stateUpdateStageAsEntered()
      this.$router.push({ name: 'Restitution', params: {} })
    },

    stateUpdateStageAsEntered() {
      this.hasEntered = true
			this.$store.commit('setStage', { stage: 'ENTERED' })
		},

    toggleMenu () {
      this.menuActive=!this.menuActive
    },
    toggleAR () {
      this.arActive=!this.arActive
    },
    reload () {
      // window.location.reload(true);
      this.$forceUpdate();
      window.location.href=`http://192.168.8.104:8080/index.html?${Date.now()}`
    }
  }
}
</script>

<style lang="scss">

// @import url('https://fonts.googleapis.com/css2?family=Xanh+Mono&display=swap');
// @import url('https://fonts.googleapis.com/css2?family=Noto+Sans+TC:wght@400;700&display=swap');
@import '/fonts/fonts.css';
html, body {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  // background: hsl(0,10%,15%);
  background: hsl(0,0%,0%);
}
*, *:before, *::after {
  box-sizing: border-box;
}
#app {
  /* font-family: Avenir, Helvetica, Arial, sans-serif; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-family: 'Joanna Sans', sans-serif;
  font-weight: 400;
  font-style: normal;
  // background: red;

  // color: #00f;
  color: #fff;
  // font-weight: 400;

  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.heading, h1, h2, .serif {
  font-family: 'Caslon', serif;
}
.sans-serif {
  font-family: 'Joanna Sans', sans-serif;
}


.router-view {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  @apply select-none;
}

#usdz-link {
  position: fixed;
  z-index: 99;
  bottom: 0;
  left: 0;
}

.info {
  // position: fixed;
  // z-index: 50;
  // top: 0;
  // right: 0;
  // left: 0;
  // bottom: 0;
  // pointer-events: none;
  //
  // h1 {
  //   margin: 0;
  //   font-size: 6vw;
  //   font-weight: normal;
  //   text-align: center;
  //   color: white;
  // }
}

.menu-toggle {
  // position: fixed;
  // z-index: 99;
  // top: 0;
  // right: 0;
  // padding: .3em .75em;
  // font-weight: normal;
  // text-align: center;
  // color: white;
  // cursor: pointer;
  // &:hover {
  //   color: #00f;
  // }
}

canvas {
  &:focus,
  &:active {
    border: none;
    outline: none;
  }
}

.nav-links {
  @extend .serif;
  @apply block text-center my-3 text-white text-opacity-60 hover:text-opacity-100;
  &.router-link-active {
    @apply text-opacity-100;
    // --tw-text-opacity: 100% !important;
  }
}


.fade-enter {
  opacity: 0;
}

.fade-enter-active {
  transition: opacity 1s ease;
}

.fade-leave {}

.fade-leave-active {
  transition: opacity 1s ease;
  transition-delay: 1s;
  opacity: 0;
}

.fadeslow-enter {
  opacity: 0;
}

.fadeslow-enter-active {
  transition: opacity 1s ease;
}

.fadeslow-leave {}

.fadeslow-leave-active {
  transition: opacity 1s ease;
  opacity: 0;
}

.fademenu-enter {
  opacity: 0;
}

.fademenu-enter-active {
  transition: opacity 0.3s ease;
}

.fademenu-leave {}

.fademenu-leave-active {
  transition: opacity 0.3s ease;
  opacity: 0;
}

.bg-light {
  background: #c6bbbb;
}

.view {
  pointer-events: auto;
  background: #c6bbbb;
  @apply min-h-full w-full overflow-y-auto;
  @apply overflow-x-hidden;
  @apply select-none;

  @screen md {
    @apply overflow-x-auto;
  }

  header {
    @apply max-w-4xl mx-auto pb-6;
    @apply px-4;
    @apply pt-32;
    @screen xl {
      @apply px-8;
      @apply pt-40;
    }
    @screen 2xl {
      @apply pt-48;
    }
    h1 {
      @extend .serif;
      @apply text-5xl;
      @screen xl {
        @apply text-7xl;
      }
      @screen 2xl {
        @apply text-8xl;
      }
    }
  }

  article {
    @apply max-w-3xl mx-auto pt-6 pb-48;
    @apply px-4;
    @apply text-xl;
    @screen xl {
      @apply px-8;
    }
  }
}
//
article {
  // @apply overflow-x-hidden;

  img {
    @apply mt-20
  }
  img + em {
    @apply text-sm not-italic mt-2 mb-10 inline-block;
    em {
      @apply italic;
    }
  }

  h1 {
    @extend .serif;
    @apply text-5xl;
    @screen xl {
      @apply text-7xl;
    }
    @screen 2xl {
      @apply text-8xl;
    }
  }

  p, blockquote {
    @apply my-6 relative;
    line-height: 1.4;
  }

  h6 {
    @apply my-8 text-sm;
  }

  &.essay {

    h3 { 
      @extend .sans-serif;
      @apply w-full;
      @apply text-xl;
      @screen lg {
        @apply text-2xl;
        margin-left: -3rem;
    }
    }
  }

  &.q-and-a {
    @apply max-w-4xl;

    h3 {
      @extend .sans-serif;
      @apply w-full;
      @apply text-xl my-8 mb-16;
      @screen md {
        @apply text-2xl px-16;
      }
    }
    p, h6 {
      @apply pl-12;
      @screen md {
        @apply px-16;
      }
      @screen lg {
        @apply px-16;
        // @apply text-blue;
      }
      @screen xl {
        @apply px-16;
        @apply text-white;
      }
    }
    .name,
    a[href^='#name'],
    a[href=''] {
      @apply pointer-events-none;

      @apply absolute tracking-widest inline-block;
      @apply -left-0;
      // @apply left-8;
      font-size: 70%;
      margin-top: .6em;

      @screen md {
        font-size: 80%;
        margin-top: .33em;
        // @apply -left-16;
        @apply left-0;
      }
    }
    img {
      max-width: calc(100% + 3rem);
      margin-left: -3rem;
      @screen lg {
        max-width: 140%;
        margin-left: -20%;
      }
    }
    img + em {
      max-width: calc(100% + 3rem);
      margin-left: -3rem;
      @screen lg {
        max-width: 140%;
        margin-left: -20%;
      }
    }
    blockquote {
      & > p {
        // @apply pl-0;
        // @screen md {
        //   @apply pl-0;
        // }
      }
      blockquote {
        @apply relative pl-0 mb-8;

        font-size: 75%;
        @screen lg {
          font-size: 60%;
        }

        p {
          @apply mt-0;

          a {
            @apply underline;
          }
        }

        @screen lg {
          position: absolute;
          font-size: 60%;
          width: 18rem;
          max-width: calc(50vw - 19rem);
          left: 100%;
          top: 0;
          padding-left: .5rem;
          text-indent: -0.7em;
          margin-top: 0;
          margin-left: -4rem;
          margin-bottom: 0;
          padding-top: .8em;
          // @apply bg-black;
          p {
            @apply pl-0;
          }
        }

        @screen xl {
          position: absolute;
          font-size: 60%;
          width: 16rem;
          max-width: calc(50vw - 20rem);
          left: 100%;
          top: 0;
          padding-left: 1rem;
          text-indent: -0.7em;
          margin-top: 0;
          margin-left: -2rem;
          margin-bottom: 0;
          padding-top: .8em;
          // @apply bg-blue;

          p {
            @apply pl-0;
          }

          &:first-child {
            margin-top: 0.6rem;
          }
        }

      }
    }
  }
}
</style>
